import * as Sentry from '@sentry/react'
import {isAbortError, isChunkLoadError} from './ApiError'
import {isSentryEnabled} from './sentry'

const stringifyError = (err: unknown): string => {
  if (err instanceof Error) return err.message || err.toString()
  if (typeof err === 'string') return err
  try {
    return JSON.stringify(err)
  } catch {
    return String(err)
  }
}

const normalizeError = (err: unknown, name?: string): Error => {
  if (err instanceof Error) {
    if (name) err.name = name
    return err
  }
  const e = new Error(stringifyError(err))
  if (name) e.name = name
  return e
}

export const reportError = (err: unknown, name?: string, extra?: Record<string, unknown>): void => {
  if (isAbortError(err) || isChunkLoadError(err)) return
  if (typeof console !== 'undefined') console.error(`[reportError] ${name ?? 'unknown'}:`, err)
  if (!isSentryEnabled()) return
  Sentry.withScope((scope) => {
    if (extra) {
      for (const [k, v] of Object.entries(extra)) scope.setExtra(k, v)
    }
    Sentry.captureException(normalizeError(err, name))
  })
}
